import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { postRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import './InviteColleagues.scss';

class InviteColleagues extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showConfirmationScreen: false,
      errorMessage: null,
      uninvitedColleagues: props.uninvitedColleagues,
      email: '',
      invalidEmail: true,
      invite: [],
      sentInvite: [],
      message: '',
      level: 'invoice_approver',
    };
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleAddEmail = this.handleAddEmail.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.validateEmailUniqueness = this.validateEmailUniqueness.bind(this);
    this.validateEmailDomain = this.validateEmailDomain.bind(this);
    this.toggleInvite = this.toggleInvite.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderSelectColleagues = this.renderSelectColleagues.bind(this);
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false, showConfirmationScreen: false });
  }

  handleInputChange(v) {
    const { invalidEmail } = this.state;
    const { target } = v;
    this.setState({ [target.name]: target.value });
    if (target.type === 'email') {
      this.setState({ invalidEmail: target.value === '' || target.validity.typeMismatch, errorMessage: null });
    }
    return !invalidEmail;
  }

  validateEmailUniqueness(email) {
    const { uninvitedColleagues } = this.state;
    const { invitedColleagues } = this.props;
    return (
      invitedColleagues === null
      || (invitedColleagues.filter((f) => f.email === email).length < 1
      && uninvitedColleagues.filter((c) => c.email === email && c.invite === true).length < 1)
    );
  }

  validateEmailDomain(email, inviterEmailDomain) {
    const { limitInvitesWithinCompany } = this.props;

    if (!limitInvitesWithinCompany) {
      return true;
    }
    return (email.indexOf(`@${inviterEmailDomain}`, email.length - `@${inviterEmailDomain}`.length) !== -1);
  }

  handleAddEmail() {
    const { limitInvitesWithinCompany, inviterEmailDomain } = this.props;
    const { email, invite, uninvitedColleagues } = this.state;

    if (!this.validateEmailUniqueness(email)) {
      this.setState({ errorMessage: 'This colleague has already been invited.' });
    } else if (limitInvitesWithinCompany && !this.validateEmailDomain(email, inviterEmailDomain)) {
      this.setState({ errorMessage: 'You can only invite colleagues within your company.' });
    } else {
      const colleague = uninvitedColleagues.filter((c) => c.email === email)[0];
      if (colleague) {
        colleague.invite = true;
      } else {
        const invitee = { email, name: email, invite: true };
        uninvitedColleagues.unshift(invitee);
      }
      invite.push(email);
      this.setState({
        invite, uninvitedColleagues, email: '', invalidEmail: true,
      });
    }
  }

  handleEnter(e) {
    const { location, resourceId } = this.props;
    if (e.key === 'Enter') {
      e.preventDefault();
      if (this.handleInputChange(e)) {
        this.handleAddEmail();
        analyticsTrack('Clicked Add Email', {
          location: `${location} - Invite Colleague by Email`,
          resource_id: resourceId,
        });
      }
    }
  }

  toggleInvite(currentInviteStatus, invitee) {
    const { invite, uninvitedColleagues } = this.state;
    if (currentInviteStatus) {
      /* eslint no-param-reassign: ["error", { "props": false }] */
      invitee.invite = false;
      this.setState({ uninvitedColleagues, invite: invite.filter((i) => i !== invitee.email) });
    } else {
      invitee.invite = true;
      invite.push(invitee.email);
      this.setState({ invite, uninvitedColleagues });
    }
  }

  handleSubmit() {
    const {
      csrfToken, resource, resourceId, inviteUrl, handleFeedbacks,
      preventCloseModalAfterSubmit, location, confirmationScreenAfterSend,
    } = this.props;
    const {
      invite, message, level, uninvitedColleagues,
    } = this.state;
    postRequest(
      inviteUrl,
      {
        emails: invite,
        message,
        level,
        resource_id: resourceId,
      },
      csrfToken,
    ).then((response) => {
      this.setState({
        uninvitedColleagues: uninvitedColleagues.filter((c) => !c.invite),
        sentInvite: invite, // for confirmation screen
        invite: [],
        showConfirmationScreen: confirmationScreenAfterSend,
        message: '',
      });
      if (!preventCloseModalAfterSubmit) { this.handleCloseModal(); }
      handleFeedbacks(response.data, uninvitedColleagues.filter((c) => !c.invite));
      analyticsTrack('Invited Colleagues to Provide Feedback', {
        emails: invite,
        location: `${location} - Submitted Modal Form`,
        resource_id: resourceId,
        resource,
      });
    });
  }

  renderSelectColleagues() {
    const { uninvitedColleagues } = this.state;
    const { resource } = this.props;
    return (
      <div className="body-text-2 mb-4">
        <p className=" mb-3 ">Select colleagues</p>
        <div className="scroll-colleagues">
          { uninvitedColleagues.map((colleague) => (
            <div
              key={colleague.email}
              tabIndex={0}
              role="button"
              className={`g-row--always g-flex-align-center select-colleague select-colleague-${resource} ${colleague.invite ? 'green' : 'grey'}`}
              onClick={() => this.toggleInvite(colleague.invite, colleague)}
            >
              <div className="add-colleague me-2">
                <i className={`${colleague.invite ? 'fa fa-check' : 'far fa'}-square`} />
              </div>
              <div className={`fs-hide ${colleague.invite ? 'green' : 'grey'}`}>
                <div>{ colleague.name ? colleague.name : colleague.email }</div>
                <div className="body-text-3">
                  { colleague.name && colleague.email && colleague.email }
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderButtonOrLink() {
    const {
      styleType, styleClass, cta, disabled, resource,
    } = this.props;
    if (styleType === 'button') {
      return (
        <button
          disabled={disabled}
          className={`invite-trigger invite-trigger-${resource} btn ${styleClass}`}
          onClick={this.handleShowModal}
        >
          {cta}
        </button>
      );
    } if (styleType === 'icon') {
      return (
        <button
          className="btn btn-secondary-no-border"
          onClick={this.handleShowModal}
          type="button"
        >
          <i className={`${styleClass}`} />
          <span className="ps-3">{cta}</span>
        </button>
      );
    }
    return (
      <a
        tabIndex={0}
        role="button"
        className={`invite-trigger invite-trigger-${resource} ${disabled && 'disabled'} body-text-2`}
        onClick={!disabled && this.handleShowModal}
      >
        <i className="fa fa-plus" />
        {cta}
      </a>
    );
  }

  render() {
    const {
      resource,
      header,
      subtext,
      cta,
      submitCta,
      messageHeader,
      ownerMessagePlaceholder,
      modalClassName,
      children,
    } = this.props;
    const {
      invite,
      sentInvite,
      uninvitedColleagues,
      showModal,
      email,
      errorMessage,
      message,
      showConfirmationScreen,
    } = this.state;
    const inviteLength = invite ? invite.length : 0;
    const uninvitedColleaguesLength = uninvitedColleagues ? uninvitedColleagues.length : 0;

    return (
      <div>
        {this.renderButtonOrLink()}
        <Modal show={showModal} onHide={this.handleCloseModal} className={modalClassName}>
          <Modal.Header closeButton className="no-border-bottom" />
          <Modal.Body>
            <div className="invite-colleagues-modal style-guide">
              { showConfirmationScreen
                && (
                <div>
                  <h1>
                    {resource}
                    {' '}
                    successfully shared with:
                  </h1>
                  { sentInvite.map((recipient) => (
                    <div className="body-text-1">{recipient}</div>
                  ))}
                </div>
                )}
              { !showConfirmationScreen
                && (
                <div>
                  <h2 className="mb-8">{header}</h2>
                  <p>
                    {subtext}
                  </p>
                  <div className="invite-form">
                    <form className="body-text-2" onSubmit={(event) => event.preventDefault()}>
                      <label htmlFor="email">
                        Email addresses
                      </label>
                      <input
                        name="email"
                        className={`fs-hide email ${errorMessage ? 'error-padding' : ''}`}
                        type="email"
                        placeholder="Press enter after each email address"
                        value={email}
                        onKeyPress={(val) => this.handleEnter(val)}
                        onChange={(val) => this.handleInputChange(val)}
                      />
                      <div className="email-warning body-text-3">
                        <i className="fa fa-exclamation-triangle" />
                        <span className="body-text-3 medium-weight">
                          Press Enter
                        </span>
                        {' '}
                        after typing the email address
                      </div>
                      { errorMessage
                        && <div className="body-text-3 email-error">{errorMessage}</div>}
                      { (inviteLength + uninvitedColleaguesLength) > 0
                         && this.renderSelectColleagues() }

                      <div>
                        { uninvitedColleaguesLength > 0
                          && <hr className="mt-40 mb-4" />}
                        <label htmlFor="owner-comment">
                          {messageHeader}
                          {' '}
                          <span className="muted-gray-text normal-weight">
                            (Optional)
                          </span>
                        </label>
                        <textarea
                          name="message"
                          className="fs-hide owner-comment"
                          placeholder={ownerMessagePlaceholder}
                          value={message}
                          onChange={(val) => this.handleInputChange(val)}
                        />
                      </div>

                      <div className={children ? 'right' : 'center'}>
                        <button id={`send-invite-${resource}`} className="send-invite btn btn-primary" disabled={invite.length < 1} onClick={this.handleSubmit}>
                          {submitCta || cta || 'Send Invite'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                )}
            </div>
          </Modal.Body>
          {children}
        </Modal>
      </div>
    );
  }
}

InviteColleagues.propTypes = {
  disabled: PropTypes.bool,
  resource: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  inviteUrl: PropTypes.string.isRequired,
  invitedColleagues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  uninvitedColleagues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleFeedbacks: PropTypes.func.isRequired,
  styleType: PropTypes.string,
  styleClass: PropTypes.string,
  cta: PropTypes.string,
  header: PropTypes.string,
  subtext: PropTypes.string,
  messageHeader: PropTypes.string,
  ownerMessagePlaceholder: PropTypes.string,
  children: PropTypes.node,
  modalClassName: PropTypes.string,
  preventCloseModalAfterSubmit: PropTypes.bool,
  submitCta: PropTypes.string,
  limitInvitesWithinCompany: PropTypes.bool,
  inviterEmailDomain: PropTypes.string,
  confirmationScreenAfterSend: PropTypes.bool,
};

InviteColleagues.defaultProps = {
  disabled: false,
  styleType: 'link',
  styleClass: '',
  cta: 'Add Colleagues',
  header: 'Share with colleagues',
  subtext: 'Colleagues will be able to review and leave comments on the project until Clora starts vetting consultants.',
  messageHeader: 'Add a message for your colleague:',
  ownerMessagePlaceholder: 'Type your message here, what should your colleagues review?',
  children: null,
  modalClassName: '',
  preventCloseModalAfterSubmit: false,
  submitCta: null,
  limitInvitesWithinCompany: false,
  inviterEmailDomain: '',
  confirmationScreenAfterSend: false,
};

export default InviteColleagues;
